import { render, staticRenderFns } from "./astralRealm.vue?vue&type=template&id=53b317d6&"
import script from "./astralRealm.vue?vue&type=script&lang=js&"
export * from "./astralRealm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports